import { haversineDistance } from 'utils/haversine';

export type LocationMatchTarget = {
  cityAliases: readonly string[];
  latitude: number;
  longitude: number;
  radiusKm: number;
  browserGeoCountries?: readonly string[];
};

export type LocationMatchMethod = 'city' | 'ip_coords' | 'browser_geo' | 'none';

export type LocationMatchStatus = 'pending' | 'resolved';

export type LocationMatchResult = {
  status: LocationMatchStatus;
  matched: boolean;
  method: LocationMatchMethod;
};

export const parseCoord = (value?: string | number | null): number | null => {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : null;
};

export const matchCityAlias = (
  city?: string | null,
  aliases: readonly string[] = [],
): boolean => {
  if (!city || aliases.length === 0) return false;
  let normalized = city;
  try {
    normalized = decodeURIComponent(city);
  } catch {
    // already-decoded / malformed escape — use the raw value
  }
  normalized = normalized.trim().toUpperCase().replace(/\s+/g, ' ');
  if (!normalized || normalized === 'XX') return false;
  return aliases.some(
    (alias) =>
      normalized === alias.toUpperCase() ||
      normalized.includes(alias.toUpperCase()),
  );
};

export const isWithinRadius = (
  latitude?: string | number | null,
  longitude?: string | number | null,
  centre?: { latitude: number; longitude: number },
  radiusKm?: number,
): boolean => {
  if (!centre || radiusKm == null || radiusKm < 0) return false;
  const lat = parseCoord(latitude);
  const lon = parseCoord(longitude);
  if (lat == null || lon == null) return false;
  return (
    haversineDistance(lat, lon, centre.latitude, centre.longitude) <= radiusKm
  );
};
